// Cookie consent banner (markup: components/CookieBanner.php).
// Consent defaults are set in <head> by thespeech_consent_defaults() in functions.php.
const COOKIE_NAME = "thespeech_cookie_consent";
const COOKIE_DAYS = 180;

const banner = document.getElementById("cookie-banner");

if (banner) {
  const getChoice = () => {
    const match = document.cookie.match(
      new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]+)")
    );
    return match ? match[1] : null;
  };

  const saveChoice = (choice) => {
    const secure = location.protocol === "https:" ? "; Secure" : "";
    document.cookie =
      COOKIE_NAME + "=" + choice +
      "; max-age=" + COOKIE_DAYS * 86400 +
      "; path=/; SameSite=Lax" + secure;

    if (typeof window.gtag === "function") {
      const state = choice === "accepted" ? "granted" : "denied";
      window.gtag("consent", "update", {
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state,
        analytics_storage: state,
      });
    }
    banner.hidden = true;
  };

  if (!getChoice()) {
    banner.hidden = false;
  }

  document.getElementById("cookie-accept").addEventListener("click", () => saveChoice("accepted"));
  document.getElementById("cookie-decline").addEventListener("click", () => saveChoice("declined"));

  const settings = document.getElementById("cookie-settings");
  if (settings) {
    settings.addEventListener("click", () => {
      banner.hidden = false;
    });
  }
}
